import {createContext, ReactElement, ReactNode} from "react";

import {AppContext as AppContextType} from "@/ts/appContext";
import {getAppContext} from "@/utils/getAppContext";

export const AppContext = createContext<AppContextType | null>(null);

export function AppContextProvider({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  // Permet de définir le type d'utilisateur en fonction du hostname
  // En local, vous pouvez modifier cette valeur pour tester les différentes vues :
  // - "Collaborateur" : Vue administrateur COFAQ
  // - "Fournisseur" : Vue fournisseur
  // - "Adherent" : Vue adhérent
  const paramsContext =
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("127.0.0.1")
      ? {usertype: import.meta.env.VITE_APP_USER_TYPE} // Modifier ici pour tester : "Collaborateur", "Fournisseur" ou "Adherent"
      : {path: window.location.hostname};
  // Récupère le contexte de l'application

  const appContext = getAppContext(paramsContext);
  if (!appContext) {
    throw new Error(
      "AppContext introuvable : la configuration de l'application est invalide."
    );
  }
  return (
    <AppContext.Provider value={{...appContext}}>
      {children}
    </AppContext.Provider>
  );
}
